import { checkModule, checkRole } from './index';
import type { NavAccessContext, NavGuard, OrgKind } from '../types/navigation';

const ORG_TYPE_ID: Record<OrgKind, number> = { designer: 1, supplier: 2 };

export const hasModule = (module: string): NavGuard => ({ kind: 'module', module });
export const hasAnyRole = (...roles: string[]): NavGuard => ({ kind: 'anyRole', roles });
export const isOrgType = (orgType: OrgKind): NavGuard => ({ kind: 'orgType', orgType });
export const allOf = (...guards: NavGuard[]): NavGuard => ({ kind: 'all', guards });
export const anyOf = (...guards: NavGuard[]): NavGuard => ({ kind: 'any', guards });

export const evaluateNavGuard = (
  guard: NavGuard | undefined,
  context: NavAccessContext
): boolean => {
  if (!guard) {
    return true;
  }
  switch (guard.kind) {
    case 'module':
      return checkModule(guard.module, context.modules);
    case 'anyRole':
      return guard.roles.some(role => checkRole(role, context.roleNames));
    case 'orgType':
      return context.orgType === ORG_TYPE_ID[guard.orgType];
    case 'all':
      return guard.guards.every(inner => evaluateNavGuard(inner, context));
    case 'any':
      return guard.guards.some(inner => evaluateNavGuard(inner, context));
  }
};
